import { useState } from "react";

export function Avatar() {
  const [ok, setOk] = useState(true);
  if (!ok) {
    return (
      <div className="avatar-ph" role="img" aria-label="Patrick Häfner" data-testid="avatar-placeholder">
        PH
      </div>
    );
  }
  return (
    <img
      src="/assets/patrick-haefner.jpg"
      width="148"
      height="148"
      loading="lazy"
      alt="Patrick Häfner"
      className="avatar"
      onError={() => setOk(false)}
      data-testid="avatar-photo"
    />
  );
}
